import { createRouter, createWebHistory } from 'vue-router'
import Loader from '../views/Loader.vue'
import Office from '../views/Office.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Loader,
      meta: {
        title: 'HK PROJECTS',
        metaTags: [
          {
            rel: 'canonical',
            href: 'https://designedbyhk.com.com'
          },
          {
            name: 'title',
            content: 'HK PROJECTS'
          },
          {
            name: 'description',
            content:
              "Discover HK Projects, a creative agency specializing in website design and maintenance. Driven by passion and precision, we craft beautiful, high-performing websites for resorts, hotels, and lifestyle brands."
          },
          {
            name: 'keywords',
            content: 'portfolio, hk projects, web developer, full stack, sites web, applications web, applications mobiles, JS, PHP, SQL, ORM, frameworks, DevOps'
          },
          {
            name: 'author',
            content: 'HK PROJECTS'
          },
          {
            name: 'robots',
            content: 'index, follow'
          },
          {
            name: 'theme-color',
            content: '#000000'
          },
          {
            name: 'mobile-web-app-capable',
            content: 'yes'
          },
          {
            name: 'apple-mobile-web-app-status-bar-style',
            content: 'black'
          },
          {
            name: 'apple-mobile-web-app-title',
            content: 'HK PROJECTS'
          },
          {
            name: 'application-name',
            content: 'HK PROJECTS'
          },
          {
            name: 'twitter:card',
            content: 'summary'
          },
          {
            name: 'twitter:title',
            content: 'HK PROJECTS'
          },
          {
            name: 'twitter:description',
            content:
              "Discover HK Projects, a creative agency specializing in website design and maintenance. Driven by passion and precision, we craft beautiful, high-performing websites for resorts, hotels, and lifestyle brands."
          },
          {
            name: 'twitter:image',
            content: 'https://designedbyhk.com/img/logo-portfolio-black.png'
          },
          {
            name: 'twitter:image:alt',
            content: 'HK PROJECTS Logo'
          },
          {
            property: 'og:type',
            content: 'website'
          },
          {
            property: 'og:title',
            content: 'HK PROJECTS'
          },
          {
            property: 'og:description',
            content:
              "Discover HK Projects, a creative agency specializing in website design and maintenance. Driven by passion and precision, we craft beautiful, high-performing websites for resorts, hotels, and lifestyle brands."
          },
          {
            property: 'og:site_name',
            content: 'HK PROJECTS'
          },
          {
            property: 'og:url',
            content: 'https://designedbyhk.com'
          },
          {
            property: 'og:image',
            content: 'https://designedbyhk.com/img/logo-portfolio-black.png'
          },
          {
            property: 'og:image:alt',
            content: 'HK PROJECTS Logo'
          },
          {
            property: 'og:locale',
            content: 'fr_FR'
          },
          {
            property: 'og:locale:alternate',
            content: 'en_US'
          }
        ]
      }
    },
    {
      path: '/office',
      name: 'Office',
      component: Office,
      meta: {
        title: 'HK PROJECTS',
        metaTags: [
          {
            rel: 'canonical',
            href: 'https://designedbyhk.com/office'
          },
          {
            name: 'title',
            content: 'HK PROJECTS'
          },
          {
            name: 'description',
            content:
              "Discover HK Projects, a creative agency specializing in website design and maintenance. Driven by passion and precision, we craft beautiful, high-performing websites for resorts, hotels, and lifestyle brands."
          },
          {
            name: 'keywords',
            content: 'hk projects, web developer, full stack, sites web, applications web, applications mobiles, JS, PHP, SQL, ORM, frameworks, DevOps'
          },
          {
            name: 'author',
            content: 'HK PROJECTS'
          },
          {
            name: 'robots',
            content: 'index, follow'
          },
          {
            name: 'theme-color',
            content: '#000000'
          },
          {
            name: 'mobile-web-app-capable',
            content: 'yes'
          },
          {
            name: 'apple-mobile-web-app-status-bar-style',
            content: 'black'
          },
          {
            name: 'apple-mobile-web-app-title',
            content: 'HK PROJECTS'
          },
          {
            name: 'application-name',
            content: 'HK PROJECTS'
          },
          {
            name: 'twitter:card',
            content: 'summary'
          },
          {
            name: 'twitter:title',
            content: 'HK PROJECTS'
          },
          {
            name: 'twitter:description',
            content:
              "Discover HK Projects, a creative agency specializing in website design and maintenance. Driven by passion and precision, we craft beautiful, high-performing websites for resorts, hotels, and lifestyle brands."
          },
          {
            name: 'twitter:image',
            content: 'https://designedbyhk.com/img/logo-portfolio-black.png'
          },
          {
            name: 'twitter:image:alt',
            content: 'HK PROJECTS Logo'
          },
          {
            name: 'og:type',
            content: 'website'
          },
          {
            name: 'og:title',
            content: 'HK PROJECTS'
          },
          {
            name: 'og:description',
            content:
              "Discover HK Projects, a creative agency specializing in website design and maintenance. Driven by passion and precision, we craft beautiful, high-performing websites for resorts, hotels, and lifestyle brands."
          },
          {
            name: 'og:site_name',
            content: 'HK PROJECTS'
          },
          {
            name: 'og:url',
            content: 'https://designedbyhk.com/office'
          },
          {
            name: 'og:image',
            content: 'https://designedbyhk.com/img/logo-portfolio-black.png'
          },
          {
            name: 'og:image:alt',
            content: 'HK PROJECTS Logo'
          },
          {
            name: 'og:locale',
            content: 'fr_FR'
          },
          {
            name: 'og:locale:alternate',
            content: 'en_US'
          }
        ]
      }
    }
  ]
})

export default router
